var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2 px-1"},[_c('custom-separator',{staticClass:"case-separator py-3",attrs:{"text":_vm.$t('ListOfRequests')}}),_vm._l((_vm.items),function(item,index){return _c('request-row',{key:`request-item-${index}`,attrs:{"data":item},on:{"on-go-to-request":_vm.onGoToRequestHandler}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }